import Box from '@mui/material/Box';
import { InputError, LightTooltip } from '../../utils';
import { useState } from 'react';
import { privateKeyToPublicKey } from "./GenerateKeysAndCsr";

export default function UploadKey({setOpenModal, setPrivateKeyPem, setPublicKeyPem,setIsUploadedKey}) {

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState('');
    const [privateKey, setPrivateKey] = useState('');
    const [publicKey, setPublicKey] = useState('');

    async function handleFileChange (event) {
        const file = event.target.files[0];
    
        // Check if the file is a TXT file
        if (file && file.type === 'text/plain') {
            setSelectedFile(file);
            setFileError('');

            const reader = new FileReader();
            reader.onload = (e) => {
                setPrivateKey(e.target.result);
                const generatedPublicKey = privateKeyToPublicKey(e.target.result);
                setPublicKey(generatedPublicKey);
            };
            reader.readAsText(file);

        } else {
          setSelectedFile(null);
          setPrivateKey('')
          setFileError('لطفا فایل خود را با فرمت txt. وارد کنید.');
        }
    }

    const handleButtonClick = () => {
        document.getElementById('fileInput').click();
    };

    function onSubmit() {
    
        if(privateKey.length == 0 || publicKey.length == 0) {
            setFileError('ابتدا کلید خود را آپلود کنید.')
            setOpenModal(true)
        }else{
            setFileError('')
            setPrivateKeyPem(privateKey)
            setPublicKeyPem(publicKey)
            setOpenModal(false);
            setIsUploadedKey(true);
        }

    }

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
        borderRadius: '10px',
        height: "auto",
        [theme.breakpoints.down('md')]: {
            width: "80%",
        },
    }) ;

    return(
        <Box sx={style } className="upload-key-size">
            <div>
                <p className="header-text mt-1" style={{"color" : "black", "lineHeight" : "normal"}}>آپلود کلید خصوصی شما</p>
                <p className="text-format" style={{ "lineHeight" : "10px", "fontSize" : "16px"}}>کلید خصوصی خود را آپلود کنید</p>
            </div>

            <div className='row justify-content-center my-4'>

                <div className='col-12'>
                    <label className="form-label text-form-title"  
                    >فایل کلید خصوصی</label>
                    <LightTooltip tooltip_title={'کلید خصوصی'}/>

                    <div className='d-flex'>

                        <input
                            type="file"
                            id="fileInput"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />

                        <input 
                            type="text"
                            name="ceard_meli_picture" 
                            className="form-control text-form-input"  
                            placeholder="فایل" 
                            style={{"width": "80%"}}
                            value={selectedFile ? selectedFile.name : ''}
                            readOnly
                        />
                        <button className='btn btn-info me-2' style={{"textWrap" : "nowrap", "color" : "white"}}  onClick={handleButtonClick} >انتخاب فایل</button>
                    </div>
                </div>

                {fileError && <InputError message={fileError} show={true}/>}

                <div className='col-12 mt-3'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                        <path d="M10 -8.74228e-07C14.3717 -4.92038e-07 17.9167 3.58224 17.9167 8C17.9167 12.4178 14.3717 16 10 16C5.62825 16 2.08333 12.4178 2.08333 8C2.08333 3.58224 5.62825 -1.25642e-06 10 -8.74228e-07ZM16.9401 0.842105C17.0312 0.858553 17.1126 0.904605 17.1745 0.973684C18.9176 2.79276 20 5.26974 20 8C20 10.3125 19.2253 12.4539 17.9297 14.1579C17.7865 14.3437 17.5212 14.375 17.3372 14.2303C17.1533 14.0855 17.1224 13.8174 17.2656 13.6316C18.4538 12.0691 19.1667 10.1234 19.1667 8C19.1667 5.49342 18.1755 3.22039 16.5755 1.55263C16.4486 1.4227 16.4193 1.22533 16.5023 1.06414C16.5853 0.90296 16.7627 0.8125 16.9401 0.842105ZM3.20312 0.842104C3.35449 0.870064 3.47982 0.980262 3.52539 1.12993C3.57259 1.2796 3.53353 1.44243 3.42448 1.55263C1.82454 3.22039 0.833333 5.49342 0.833333 8C0.833333 10.1234 1.54622 12.0691 2.73437 13.6316C2.8776 13.8174 2.84668 14.0855 2.66276 14.2303C2.47884 14.375 2.21354 14.3437 2.07031 14.1579C0.774739 12.4539 -9.01547e-07 10.3125 -6.99382e-07 8C-4.60695e-07 5.26974 1.08236 2.79276 2.82552 0.973683C2.92155 0.86842 3.06315 0.817433 3.20312 0.842104ZM10.4167 2.94737L9.58333 2.94737C9.35384 2.94737 9.16667 3.13651 9.16667 3.36842L9.16667 8.8421C9.16667 9.07401 9.35384 9.26316 9.58333 9.26316L10.4167 9.26316C10.6462 9.26316 10.8333 9.07401 10.8333 8.8421L10.8333 3.36842C10.8333 3.13651 10.6462 2.94737 10.4167 2.94737ZM10.4167 10.9474L9.58333 10.9474C9.35384 10.9474 9.16667 11.1365 9.16667 11.3684L9.16667 12.2105C9.16667 12.4424 9.35384 12.6316 9.58333 12.6316L10.4167 12.6316C10.6462 12.6316 10.8333 12.4424 10.8333 12.2105L10.8333 11.3684C10.8333 11.1365 10.6462 10.9474 10.4167 10.9474Z" fill="#FF2B2B"/>
                    </svg>
                    <span className="text-format me-2" style={{ "color" : "#FF2B2B", "fontSize" : ".0.9rem"}}>لطفا کلید خصوصی خود را آپلود کنید و مطمئن باشید فقط در اختیار خودتان است</span>
                </div>

            </div>

            <div className='row justify-content-center'>
            
                <div className='col-12 text-form-title'>
                    <label className="mb-1" style={{"color": "#9F6900"}}>کلید خصوصی وارد شده</label>

                    <div className="rounded p-2 d-block ltr" style={{"background" : "#f8f9c4"}}>

                        <p className='truncate-text pt-2 m-0 blur-text'>{privateKey}</p>

                    </div>
                </div>

                <div className='col-12 text-form-title mt-3'>
                    <label className="mb-1" style={{"color": "#0079AF"}}>کلید عمومی متناظر</label>

                    <div className="rounded p-2 d-block justify-content-between ltr" style={{"background" : "#C8EEFF"}}>
                        
                        <div style={{"margin": "auto 0"}}>
                            <p className="m-0 px-3 text-format truncate-text" style={{"color" : "#0079AF"}}>{publicKey}</p>
                        </div>
                    </div>
                </div>
            
            </div>

            <div className='row mt-4 justify-content-center'>

                <div className='col-7 d-flex justify-content-around'>
                    <button 
                        className='btn border text-form-title w-100 mx-1' 
                        style={{"padding": "1.5% 13%"}}
                        onClick={() => setOpenModal(false)}
                    >بستن</button>

                    <button 
                        className='btn text-form-button w-100 mx-1' 
                        style={{"background" : "#044448", "padding": "1.5% 13%"}}
                        onClick={onSubmit}
                    >تایید </button>
                </div>
                
            </div>
        </Box>

    )
}